/** Unterstützte KI-Provider für das CRM */
export const AI_PROVIDERS = {
  anthropic: {
    id: 'anthropic',
    label: 'Anthropic (Claude)',
    fastModel: 'claude-haiku-4-5-20251001',
    keyPlaceholder: 'sk-ant-api03-…',
    keyHelpUrl: 'https://console.anthropic.com/settings/keys',
    keyHelpLabel: 'console.anthropic.com',
  },
  openai: {
    id: 'openai',
    label: 'OpenAI (GPT)',
    fastModel: 'gpt-4o-mini',
    keyPlaceholder: 'sk-…',
    keyHelpUrl: 'https://platform.openai.com/api-keys',
    keyHelpLabel: 'platform.openai.com',
  },
  gemini: {
    id: 'gemini',
    label: 'Google Gemini (Free Tier)',
    fastModel: 'gemini-2.0-flash',
    keyPlaceholder: 'AIza…',
    keyHelpUrl: 'https://aistudio.google.com/apikey',
    keyHelpLabel: 'aistudio.google.com',
    freeTierHint: 'Kostenloser Free Tier – meist ohne Kreditkarte. Key unter Google AI Studio erstellen.',
  },
};

export const AI_PROVIDER_IDS = Object.keys(AI_PROVIDERS);
export const DEFAULT_AI_PROVIDER = 'anthropic';
